export default "__VITE_ASSET__B17Urp_l__"